<div class="ap-skeleton__square" aria-live="polite" aria-busy="true" [style.height]="squareHeight()"></div>
